import { FC } from "react";

interface IntroStepProps {
  onBegin: () => void;
}

export const IntroStep: FC<IntroStepProps> = ({ onBegin }) => {
  return (
    <>
      {/* Header */}
      <div className="flex flex-col gap-2 items-center text-center">
        <h1 className="text-2xl sm:text-4xl font-medium text-white">
          Fund your trading account
        </h1>
        <p className="text-sm sm:text-base text-sr-pink-muted">
          Deposit assets into Sugar Rush to start trading
        </p>
      </div>

      {/* How it works */}
      <div className="w-full flex flex-col gap-3">
        <p className="text-base font-medium text-white">How it works</p>
        <div className="flex flex-col gap-0.5">
          <div className="sr-card-stacked-top">
            <ol start={1} className="text-sm font-medium text-white list-decimal ml-5">
              <li>Connect your wallet</li>
            </ol>
          </div>
          <div className="sr-card-stacked-mid">
            <ol start={2} className="text-sm font-medium text-white list-decimal ml-5">
              <li>Deposit assets</li>
            </ol>
          </div>
          <div className="sr-card-stacked-mid">
            <ol start={3} className="text-sm font-medium text-white list-decimal ml-5">
              <li>Wait for network confirmation</li>
            </ol>
          </div>
          <div className="sr-card-stacked-bottom">
            <ol start={4} className="text-sm font-medium text-white list-decimal ml-5">
              <li>Start trading once funds are available</li>
            </ol>
          </div>
        </div>
      </div>

      {/* Non-custodial callout */}
      <div className="sr-highlight-box w-full">
        <div className="flex flex-col gap-1.5">
          <p className="text-base font-medium text-sr-pink-light">
            Non-custodial by design
          </p>
          <p className="text-xs text-sr-pink-bright">
            Your deposit is protected by broad network consensus, not a single
            exchange operator holding unilateral control of your funds.
          </p>
        </div>
      </div>

      {/* CTA */}
      <button className="sr-btn-primary" onClick={onBegin}>
        Begin deposit
      </button>
    </>
  );
};
